import { render, staticRenderFns } from "./FragmentMDHeading.vue?vue&type=template&id=1aa89526"
import script from "./FragmentMDHeading.vue?vue&type=script&lang=ts"
export * from "./FragmentMDHeading.vue?vue&type=script&lang=ts"
import style0 from "./FragmentMDHeading.vue?vue&type=style&index=0&id=1aa89526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports